export const getUserProfile = userId => {
  return `
		SELECT
			Profile.Name,
			ProfileId,
			Email,
			Name
		FROM
			User
		WHERE
			Id = '${userId}'
		LIMIT 1
	`;
};
